export default "__VITE_ASSET__DyHaO1Yr__"